import React, { useContext, useState, useEffect } from 'react'

import { useHistory } from 'react-router-dom'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import { Button } from '@mui/material'
import { useFormik } from 'formik'
import AlertContext from '@/product/context/alert/alertContext'
import ProductContext from '@/product/context/product/productContext'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import CustomDialog from '@/product/components/organisms/Dialog'
import settingContext from '@/custom/context/setting/settingContext'
import { v4 as uuidv4 } from 'uuid'
import Layout from '@/product/components/templates/Layout'
import { dateTimeFormatFunction } from '@/custom/common/components'
import StatusHistory from './StatusHistory'
import customReportContext from '@/custom/context/report/reportContext'
import { handleRedirectInternal, mapData } from '@/product/common/components'

const SellerWithdrawalRequest = (props) => {
    const alertContext = useContext(AlertContext)
    const [isLoading, setIsLoading] = useState(true)

    const productContext = useContext(ProductContext)

    const settingContexts = useContext(settingContext)
    const customReportContexts = useContext(customReportContext)
    const {
        getUserWithdrawalDetails,
        withdrawal_data,
        postWithdrawalrequest,
        responseStatus,
    } = settingContexts
    const { getAllReportCustomDownload } = customReportContexts

    const history = useHistory()

    const [reverseHandler, setReverseHandler] = useState(false)
    const [reverseId, setReverseId] = useState('')
    const [historyId, setHistoryId] = useState('')
    const [selectWithdrawal, setSelectWithdrawal] = useState(false)
    const [isStatusNotIn, setIsStatusNotIn] = useState(true)
    const [selectUpdatedId, setSelectUpdatedId] = useState([])
    const [tableStatus, setTableStatus] = useState('requested_rejected')
    const [slectId, setSelectId] = useState({
        id: 0,
        status: '',
    })
    const [selectedIds, setSelectedIds] = useState({
        id: [],
        project_id: [],
        status: '',
        condition_status: '',
    })

    /* Start of Formik Selection Action Function */
    const formikSelection = useFormik({
        initialValues: {
            action: '',
            cart_id: '',
        },
        onSubmit: (values) => {
            // console.log(values, 'fffffffff')
            // if (values.action === 'approve' || values.action === 'reject') {
            //     const value = values
            //     setIsLoading(true)
            //     changeOfferStatus(value)
            // }
        },
    })

    const onSelectMultiProducts = (data, action) => {
        const selectedRows = tableBody.filter((row) => data.includes(row.id))

        const projectIds = selectedRows.map((row) => row.project_id)
        setSelectedIds({
            id: data,
            project_id: projectIds,
            status: action,
            condition_status: '',
        })

        setSelectWithdrawal(true)
    }

    const [tableBody, setTableBody] = useState([])

    const initialValues = {
        searchterm: '',
        page: 1,
        limit: 20,
        order: 'desc',
        orderby: 'swr.id',
        // limitOptions: [5, 20, 40, 60, 100, 200],
        filters: {
            market_status: {
                value: ['open', 'closed'],
                type: 'array',
                field: 'swr.market_status',
            },
            status: {
                value: 'requested_rejected',
                type: isStatusNotIn ? 'notin' : 'in',
                field: 'swr.status',
            },
            username: {
                value: '',
                type: 'like',
                field: 'emp.username',
            },
        },
    }

    const formik = useFormik({
        initialValues,
        onSubmit: (values) => {
            setIsLoading(true)
            getUserWithdrawalDetails(values)
            setTableStatus(values?.filters?.status?.value)
            setSelectUpdatedId([])
        },
    })

    useEffect(() => {
        const isRejected =
            formik?.values?.filters?.status?.value === 'requested_rejected'

        setIsStatusNotIn(isRejected)

        formik.setFieldValue('filters.status.type', isRejected ? 'notin' : 'in')
    }, [formik?.values?.filters?.status?.value])

    useEffect(() => {
        getUserWithdrawalDetails(formik.values)
    }, [])

    const closeFunction = () => {
        setHistoryId('')
        getUserWithdrawalDetails(formik.values)
    }

    const tableActions = []
    if (formik.values.filters.status.value === '0') {
        tableActions.push({
            label: 'Move to Rejected',
            icon: <span className="material-icons">block</span>,
            onclick: onSelectMultiProducts,
            type: 'reject',
        })

        tableActions.push({
            label: 'Move to Approved',
            icon: <span className="material-icons">check_circle</span>,
            onclick: onSelectMultiProducts,
            type: 'approve',
        })
    }

    const onClickHistory = (id, secondaryID, action) => {
        setHistoryId(id)
    }

    useEffect(() => {
        if (withdrawal_data) {
            const updatedA = withdrawal_data?.records
                ?.map((item) => {
                    if (
                        item?.status === 'Fund Requested' ||
                        item?.status === 'Fund requested'
                    ) {
                        return {
                            ...item,
                            seller_status: 'Withdraw',
                            reverse_request: 'Reverse',
                        }
                    } else if (item?.status === 'In Progress') {
                        return {
                            ...item,
                            seller_status: 'Mark As Paid',
                        }
                    } else if (item.status === 'paid') {
                        return {
                            ...item,
                            seller_status: dateTimeFormatFunction(
                                item.paid_date
                            ),
                        }
                    }
                    // Return null for items that don't meet any conditions
                    return null
                })
                .filter((item) => item !== null) // Remove null items

            setTableBody(updatedA)
            setIsLoading(false)
        }
    }, [withdrawal_data])

    const changeStatusHandler = (id, secondaryID) => {
        let projects = tableBody?.filter((el) => el?.id == id)

        const currentDate = new Date()
        if (secondaryID == 'Fund Requested') {
            postWithdrawalrequest({
                id: [id],
                project_id: [projects[0]?.project_id],
                condition_status: secondaryID,
                update_status: {
                    status: 'In Progress',
                    // inprogress_date: currentDate
                    //     .toISOString()
                    //     .slice(0, 19)
                    //     .replace('T', ' '),
                },
            })
        } else if (secondaryID == 'In Progress') {
            postWithdrawalrequest({
                id: [id],
                project_id: [projects[0]?.project_id],
                condition_status: secondaryID,
                first_name: projects[0]?.emp_firstname,
                last_name: projects[0]?.emp_lastname,
                requested_amount: projects[0]?.amount,
                email: projects[0]?.emp_email,
                update_status: {
                    status: 'paid',
                    market_status: 'closed',

                    // paid_date: currentDate
                    //     .toISOString()
                    //     .slice(0, 19)
                    //     .replace('T', ' '),
                },
            })
        }
    }

    const changeMultiSelectStatus = () => {
        const currentDate = new Date()
        if (selectedIds?.status == 'Fund Requested') {
            postWithdrawalrequest({
                id: selectedIds?.id,
                project_id: selectedIds?.project_id,
                condition_status: selectedIds?.status,
                update_status: {
                    status: 'In Progress',

                    // inprogress_date: currentDate
                    //     .toISOString()
                    //     .slice(0, 19)
                    //     .replace('T', ' '),
                },
            })
        } else if (selectedIds?.status == 'In Progress') {
            postWithdrawalrequest({
                id: selectedIds?.id,
                project_id: selectedIds?.project_id,
                condition_status: selectedIds?.status,
                update_status: {
                    status: 'paid',
                    market_status: 'closed',

                    // paid_date: currentDate
                    //     .toISOString()
                    //     .slice(0, 19)
                    //     .replace('T', ' '),
                },
            })
        } else if (selectedIds?.status == 'Reverse') {
            postWithdrawalrequest({
                id: selectedIds?.id,
                project_id: selectedIds?.project_id,
                condition_status: 'Fund Requested',
                update_status: {
                    status: 'request_rejected',
                    market_status: 'removed',

                    reverse_date: currentDate
                        .toISOString()
                        .slice(0, 19)
                        .replace('T', ' '),
                },
            })
        }
    }

    const changeDialogStatus = () => {
        const currentDate = new Date()
        let projects = tableBody?.filter((el) => el?.id == reverseId)
        postWithdrawalrequest({
            id: [reverseId],
            project_id: [projects[0]?.project_id],
            condition_status: 'Fund Requested',
            update_status: {
                status: 'request_rejected',
                market_status: 'removed',

                reverse_date: currentDate
                    .toISOString()
                    .slice(0, 19)
                    .replace('T', ' '),
            },
        })
    }

    const changeWithdrawalStatus = (id, status) => {
        setSelectId({ id: id, status: status })
        setSelectWithdrawal(!selectWithdrawal)
    }

    const changeStatusRemoved = (id, secondaryID) => {
        setReverseId(id)
        setReverseHandler(true)
    }

    useEffect(() => {
        if (responseStatus?.status == 'success')
            getUserWithdrawalDetails(formik.values)
        setReverseId('')
        setReverseHandler(false)
        setSelectWithdrawal(false)
    }, [responseStatus])

    const getMultipleAction = () => {
        let actionPush = []
        actionPush.push({
            buttonType: 'flip_camera_android',
            clickType: 'editIncrement',
            onclick: changeStatusRemoved,
            secondaryClickID: 'status',
            clickID: 'id',
            tooltipTitle: 'Reverse',
            condition: true,
            conditionValue: {
                formula: {
                    isString: true,
                    key1: 'status',
                    key2: 'Fund Requested',
                    notation: '===',
                },
            },
        })
        actionPush.push({
            buttonType: 'edit',
            clickType: 'editIncrement',
            onclick: changeWithdrawalStatus,
            secondaryClickID: 'status',
            clickID: 'id',
            tooltipTitle: 'Withdrawal Status',
            condition: true,
            conditionValue: {
                formula: {
                    isString: true,
                    key1: 'status',
                    key2: 'paid',
                    notation: '!==',
                },
            },
        })
        actionPush.push({
            buttonType: 'history',
            clickType: 'editIncrement',
            onclick: onClickHistory,
            tooltipTitle: 'History',
        })

        return actionPush
    }
    const onClickView = (project_id) => {
        handleRedirectInternal(history, `listing/sold?project_id=${project_id}`)
    }
    const onClickUserView = (email) => {
        handleRedirectInternal(history, `org/all?email=${email}`)
    }

    const tableValues = [
        {
            field: 'username',
            firstChild: true,
            sort: true,
            type: 'hyperlink',
            clickID: 'emp_email',
            onclick: onClickUserView,
            disablePadding: false,
            label: 'username',
        },
        {
            field: 'seller_name',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Seller Name',
        },

        {
            field: 'project_id',
            type: 'hyperlink',
            clickID: 'project_id',
            onclick: onClickView,
            firstChild: true,
            sort: true,
            filterable: true,
            disablePadding: false,
            label: 'Product Id',
        },
        {
            field: 'amount',
            type: 'price',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Amount',
        },
        {
            field: 'requested_date',
            type: 'datetime',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Requested Date',
        },
        {
            field: 'status',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Status',
        },
        {
            field: 'reverse_request',
            // type: 'hyperlink',
            // clickID: 'id',
            firstChild: true,
            // sort: false,
            disablePadding: false,
            // onclick: changeStatusRemoved,
            // secondaryClickID: 'status',
            label: 'Reverse Request',
        },
        {
            field: 'date_added',
            type: 'datetime',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Status Date',
        },
        {
            field: 'seller_status',
            // type: 'hyperlink',
            // clickID: 'id',
            firstChild: false,
            sort: false,
            disablePadding: false,
            // onclick: changeStatusHandler,
            // secondaryClickID: 'status',
            label: 'Action',
        },
        {
            name: 'action',
            field: 'action',
            type: 'button',
            isMultiple: true,
            clickID: 'id',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            isMultiple: getMultipleAction(),
            tableShow: 1,
        },
    ]

    const searchInfo = {
        formik: formik,
        data: [
            {
                label: 'User Name',
                placeholder: 'Enter User Name',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'username',
                filter: true,
            },
            {
                label: 'Status',
                placeholder: 'Select Offer Status',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'select',
                options: [
                    {
                        show: 'All',
                        value: 'requested_rejected',
                    },
                    {
                        show: 'Fund Requested',
                        value: 'Fund Requested',
                    },
                    {
                        show: 'In Progress',
                        value: 'In Progress',
                    },
                    {
                        show: 'Paid',
                        value: 'Paid',
                    },
                ],
                name: 'status',
                filter: true,
            },
        ],
    }

    const formikCheckbox = useFormik({
        initialValues: {
            user_up: true,
            download_format: 1,
        },
        onSubmit: (values) => {},
    })

    let tempTableActions = [
        ...(tableStatus === 'Fund Requested'
            ? [
                  {
                      label: 'Move to Reverse',
                      icon: <span className="material-icons">block</span>,
                      onclick: onSelectMultiProducts,
                      type: 'Reverse',
                      action: 'active',
                  },
                  {
                      label: 'Move to In Progress',
                      icon: (
                          <span className="material-icons">check_circle</span>
                      ),
                      onclick: onSelectMultiProducts,
                      type: 'Fund Requested',
                      action: 'deactivate',
                  },
              ]
            : []),

        ...(tableStatus === 'In Progress'
            ? [
                  {
                      label: 'Move to Paid',
                      icon: (
                          <span className="material-icons">check_circle</span>
                      ),
                      onclick: onSelectMultiProducts,
                      type: 'In Progress',
                      action: 'deactivate',
                  },
              ]
            : []),
    ]

    const mapDataOptions = {
        formik: formikCheckbox,
        data: [
            {
                label: 'Merge Same User Payments',
                type: 'checkbox',
                class: 'col-12',
                name: 'user_up',
            },

            {
                title: 'Download Format',
                type: 'radio',
                name: 'download_format',
                class: 'col-12 col-sm-6',
                options: [
                    { id: 1, description: 'CSV' },
                    { id: 2, description: 'XLSX' },
                ],
                int: 1,
            },
        ],
    }
    const selectedUpdate = (ids) => {
        setSelectUpdatedId(ids)
    }

    const viewAll = () => {
        formik.values.limit = 100
        formik.submitForm()
    }
    return (
        <Layout>
            <div className="addUserModal">
                <div className="fspBody">
                    <CustomSearch searchInfo={searchInfo} formik={formik} />
                    <PrimaryButton
                        onClick={() => {
                            viewAll()
                        }}
                    >
                        View All
                    </PrimaryButton>

                    <CustomTable
                        formik={formik.values}
                        tableBody={tableBody}
                        tableValues={tableValues}
                        tableActions={
                            tableStatus === 'requested_rejected'
                                ? []
                                : tempTableActions
                        }
                        tableActionString={['active', 'rejected', 'deactivate']}
                        allData={withdrawal_data}
                        isLoading={isLoading}
                        loadingTemplate={'table'}
                        changeTableFunction={getUserWithdrawalDetails}
                        selectedUpdate={selectedUpdate}
                    />
                    <div>
                        <PrimaryButton
                            onClick={() => {
                                getAllReportCustomDownload({
                                    action: 'export',
                                    order: 'asc',
                                    orderby: '',
                                    search: 'all',
                                    isDefault: false,
                                    id: selectUpdatedId,
                                    download_xlsx:
                                        formikCheckbox?.values
                                            ?.download_format == 2
                                            ? true
                                            : false,
                                    user_merge: formikCheckbox?.values?.user_up,
                                    report: `all_seller_withdrawal_request`,
                                })
                            }}
                        >
                            Download Report
                        </PrimaryButton>

                        {mapData(mapDataOptions)}
                    </div>
                </div>

                <CustomDialog
                    open={reverseHandler}
                    closeButton={true}
                    function={changeDialogStatus}
                >
                    <h4>Bondroberts.ecommerce.auction says</h4>
                    <h6> Are you sure you wish to reverse this request?</h6>
                    <div className="actionWrapper">
                        <Button
                            className="old_residenc"
                            id="old_residenc"
                            onClick={() => {
                                setReverseId('')
                                setReverseHandler(false)
                            }}
                        >
                            Cancel
                        </Button>
                        <PrimaryButton
                            id="buy_now_submit"
                            onClick={changeDialogStatus}
                            className="ageNoBtn"
                            label={'Submit'}
                        />
                    </div>
                </CustomDialog>

                <CustomDialog
                    open={selectWithdrawal}
                    closeButton={true}
                    function={changeWithdrawalStatus}
                >
                    <h4>Bondroberts.ecommerce.auction says</h4>
                    {slectId.status == 'Fund Requested' ? (
                        <h6>
                            {`Amount deducted from wallet, please process for TaTFX!`}{' '}
                            {/* {`Are you sure you want to change ${slectId?.status} `}{' '} */}
                        </h6>
                    ) : (
                        <h6>
                            {`Balance mark as paid!
`}
                        </h6>
                    )}
                    <div className="actionWrapper">
                        <Button
                            className="old_residenc"
                            id="old_residenc"
                            onClick={() => {
                                changeWithdrawalStatus()
                            }}
                        >
                            Cancel
                        </Button>
                        <PrimaryButton
                            id="buy_now_submit"
                            className="ageNoBtn"
                            label={'Submit'}
                            onClick={() => {
                                if (slectId.id) {
                                    changeStatusHandler(
                                        slectId?.id,
                                        slectId?.status
                                    )
                                } else {
                                    changeMultiSelectStatus(selectedIds)
                                }
                            }}
                        />
                    </div>
                </CustomDialog>
                <StatusHistory
                    historyId={historyId}
                    closeFunction={closeFunction}
                />
            </div>
        </Layout>
    )
}

export default SellerWithdrawalRequest
